export default "__VITE_ASSET__9RT1YksE__"